import styled from "styled-components";

const UserMenuWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;

  button {
    margin-right: 10px;
  }

  .ant-menu-submenu-title {
    text-align: right;
  }
`;

export { UserMenuWrapper };
